import { Backdrop, CircularProgress, Typography } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import InfoIcon from '@mui/icons-material/Info'
import { getOrganizationWithID } from '../../../redux/actions/Organizations'
import {
  getAllSuborganizations,
  getTypesSuborganizations
} from '../../../redux/actions/Suborganizations'
import BreadcrumbsComponent from './Breadcrumbs/Breadcrumbs'

import SuborganizationsTable from './TableNavigable/TableNavigable'
import useStyles from './useStyle'

export const SuborganizationsOfOrganizations = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const { id } = useParams()
  const [organization, setorganization] = useState(null)
  const [types, setTypes] = useState([])

  // get user info request
  const handleGetSuborganizationWithOrgID = async () => {
    setRows(await dispatch(getAllSuborganizations(id)))
  }

  // get organization with ID
  const getOrganization = async () => {
    const response = await dispatch(getOrganizationWithID(id))
    if (response) {
      setorganization(response)
    }
  }

  // get types of suborganizations
  const getTypesSuborganization = async () => {
    const response = await dispatch(getTypesSuborganizations(id))
    setTypes(response)
  }

  // get organinzation details of reducer
  useEffect(async () => {
    setLoading(true)
    await getOrganization()
    await getTypesSuborganization()
    await handleGetSuborganizationWithOrgID()
    setLoading(false)
  }, [id])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <BreadcrumbsComponent
        name={organization ? organization.organizationName : ''}
      />
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Estudios asociados a una organización
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          La siguiente lista muestra los estudios asociados a la organización{' '}
          {organization ? organization.organizationName : ''}.
        </Typography>
      </div>

      <div className={classes.boxTable}>
        <SuborganizationsTable
          id={id}
          rows={rows}
          setRows={setRows}
          types={types}
          setLoading={setLoading}
        />
      </div>
    </div>
  )
}
